export const IMAGING_WORKLIST_PAGE_SIZE_OPTIONS = [10, 50, 100] as const;
